import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/client";
import authLink from "./links/authLink";
import httpLink from "./links/httpLink";
import retryLink from "./links/retryLink";

const link = ApolloLink.from([authLink, httpLink, retryLink ])

const client = new ApolloClient({
    cache: new InMemoryCache(),
    link,
});

export default client